import React from "react";
import { withRouter } from "react-router-dom";
import { withModels } from "../../../models/queries";
import Table from "./Table";
import ConfirmModal from "../ConfirmModal";
import Spinner from "../../../components/Spinner";
// util
import compose from "../../../utils/compose";
// styles
import styles from "./BrowseRecords.module.css";

const order = ["warr", "waste", "dest"];
function byOrder([aKey], [bKey]) {
  return order.indexOf(aKey) - order.indexOf(bKey);
}
class BrowseRecords extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilter: "warr",
      activeRecords: {},
      modal: null,
      loading: true,
    };
  }

  filters = {
    dest: "Destruction Certification",
    waste: "Wastage Replacement",
    warr: "Limited Warranty",
  };

  setFilter = (filter) => {
    return this.setState({ activeFilter: filter }, () =>
      this.props.history.push(`/admin/${filter}`)
    );
  };

  closeModal = () => {
    return this.setState({ modal: null });
  };

  openModal = (modal) => {
    return this.setState({ modal });
  };

  componentDidMount() {
    const { params } = this.props.match;
    return Promise.all([
      this.props.models.fetchWarrantyRecords(),
      this.props.models.fetchDestructionRecords(),
      this.props.models.fetchWastageRecords(),
    ]).then(([warr, dest, waste]) =>
      this.setState(
        {
          activeRecords: { dest, warr, waste },
          activeFilter: params.form,
          loading: false,
        },
        () => {
          if (!params.form) this.setFilter("warr"); //default
        }
      )
    );
  }

  componentDidUpate(prev) {
    const { params } = this.props.match;
    const { params: prevParams } = prev.match;
    if (prevParams.form === params.form) return;
    this.setState({ activeFilter: params.form });
  }

  renderTabs() {
    return (
      <div className={styles.tabArea}>
        {Object.entries(this.filters)
          .sort(byOrder)
          .map(([key, title]) => {
            return (
              <span
                key={`filter-${key}`}
                className={`${styles.tabSelect}${
                  key === this.state.activeFilter ? ` ${styles.active}` : ""
                }`}
                onClick={this.setFilter.bind(this, key)}
              >
                {" "}
                {title}{" "}
              </span>
            );
          })}
      </div>
    );
  }

  render() {
    const { activeFilter, activeRecords, modal, loading } = this.state;
    const records = activeRecords[activeFilter];
    return loading ? (
      <div
        style={{
          margin: "200px auto",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Spinner style={{ color: "red", height: 100, width: 100 }} />
      </div>
    ) : (
      <div className={styles.tableContainer}>
        {this.renderTabs()}
        {records && (
          <Table
            tableType={activeFilter}
            records={records}
            openModal={this.openModal}
            closeModal={this.closeModal}
          />
        )}
        {modal && <ConfirmModal {...modal} />}
      </div>
    );
  }
}

export default compose(withRouter, withModels)(BrowseRecords);
